<template>
    <div class="register">
        <registration-navigation :current-step="currentStep" :available-steps="availableSteps"></registration-navigation>

        <div class="register__content">

            <transition name="fade">
                <registration-step-details v-if="currentStep === 2" :errors="detailStepErrors" @changed="stepChanged"></registration-step-details>
            </transition>
            <!-- <transition name="fade">
                <registration-step-goals v-if="currentStep === 3" :errors="goalsStepErrors" @changed="stepChanged"></registration-step-goals>
            </transition>
            <transition name="fade">
                <registration-step-frequency v-if="currentStep === 4"></registration-step-frequency>
            </transition> -->

            <div class="register__wrapper register__wrapper--small">
                <puma-button class="register__submit button--border" @click="submitStep" :disabled="!stepValid" :loading="submitButtonLoading">
                    <span v-if="isLastStep" v-translate>registration_done</span>
                    <span v-else v-translate>next</span>
                </puma-button>
                <div class="form__error" v-if="submitError">{{ submitError }}</div>
            </div>
        </div>
    </div>
</template>

<script>
import * as api from '../api'
import { mapState } from 'vuex'
import { storeUser } from '../utils/authentication';
import RegistrationNavigation from "@/components/RegistrationNavigation.vue";
import RegistrationStepDetails from "@/components/RegistrationStepDetails.vue";
import RegistrationStepGoals from "@/components/RegistrationStepGoals.vue";
import RegistrationStepFrequency from "@/components/RegistrationStepFrequency.vue";

import { addTrackingObject } from "@/utils/tracking"

export default {
    name: "RegistrationSteps",
    components: {
        RegistrationNavigation,
        RegistrationStepDetails,
        RegistrationStepGoals,
        RegistrationStepFrequency,
    },
    props: {
    },
    data () {
        return {
            currentStep: parseInt(this.$route.params.step),
            // isLastStep: parseInt(this.$route.params.step) === 4,
            isLastStep: parseInt(this.$route.params.step) === 2,
            detailStepErrors: [],
            goalsStepErrors: [],
            stepValid: true,
            stepDirty: false,
            availableSteps: [],
            submitError: false,
            submitButtonLoading: false,
        }
    },
    computed: {
        ...mapState({
            'registrationUser': 'registrationUser',
        }),
    },
    beforeRouteEnter (to, from, next) {
        // if(parseInt(to.params.step) < 2 || parseInt(to.params.step) > 4){
        //     next({name: 'Register'});
        // } else {
        //     next();
        // }

         if(parseInt(to.params.step) < 2){
            next({name: 'Register'});
        } else {
            next();
        }
    },
    beforeRouteUpdate (to, from, next) {
        // if(parseInt(to.params.step) < 2 || parseInt(to.params.step) > 4){
        //     next({name: 'Register'});
        // } else {
        //     this.stepValid = true;
        //     this.stepDirty = false;
        //     this.currentStep = parseInt(this.$route.params.step);
        //     this.isLastStep = this.currentStep === 4;
        //     next();
        // }

        if(parseInt(to.params.step) < 2){
            next({name: 'Register'});
        } else {
            this.stepValid = true;
            this.stepDirty = false;
            this.currentStep = parseInt(this.$route.params.step);
            this.isLastStep = this.currentStep === 2;
            next();
        }
    },
    mounted() {
        if(this.$store.state.user && this.$store.state.registrationUser.name === null) {
            this.$store.commit('setRegistrationUser', this.$store.state.user);
        }
        this.availableSteps = this.getAvailableSteps();
        if(this.availableSteps.indexOf(this.currentStep) < 0){
            this.$router.push({name: 'RegistrationSteps', params: {'step': this.availableSteps[this.availableSteps.length - 1]}})
        }

        // addTrackingObject({subSection: "login", screenName: "registration"}, {type: "login", value: "web_registration_page"});
    },
    methods: {
        submitStep() {
            if(!this.isStepValid()) {
                this.stepDirty = true;
                this.stepValid = false;
                return false;
            }
            this.stepValid = true;
            if(this.isLastStep) {
                this.submitProfileUpdate();
            } else {
                this.goToNextStep();
            }
        },
        goToNextStep() {
            this.$router.push({name: 'RegistrationSteps', params: {step: this.currentStep + 1}})
        },
        isStepValid() {
            // switch(this.currentStep){
            //     case 2:
            //         return this.isDetailsStepValid();
            //         break;
            //     case 3:
            //         return this.isGoalsStepValid();
            //         break;
            //     case 4:
            //         return true;
            //         break;
            // }

            switch(this.currentStep){
                case 2:
                    return this.isDetailsStepValid();
            }

        },
        isDetailsStepValid(silent = false) {
            let valid = true;
            this.detailStepErrors = [];
            // if(!this.registrationUser.name || !this.registrationUser.name.length) {
            //     valid = false;
            //     if(!silent) {
            //         this.detailStepErrors.push('name');
            //     }
            // }
            if(!this.registrationUser.lastName || !this.registrationUser.lastName.length) {
                valid = false;
                if(!silent) {
                    this.detailStepErrors.push('lastName');
                }
            }
            if(!this.registrationUser.firstName || !this.registrationUser.firstName.length) {
                valid = false;
                if(!silent) {
                    this.detailStepErrors.push('firstName');
                }
            }
            // if(!this.registrationUser.dob || !this.registrationUser.dob.length) {
            //     valid = false;
            //     if(!silent) {
            //         this.detailStepErrors.push('dob');
            //     }
            // }
            if(!this.registrationUser.location || !this.registrationUser.location.length) {
                valid = false;
                if(!silent) {
                    this.detailStepErrors.push('location');
                }
            }
            // if(!this.registrationUser.sex || !this.registrationUser.sex.length) {
            //     valid = false;
            //     if(!silent) {
            //         this.detailStepErrors.push('sex');
            //     }
            // }
            return valid;
        },
        // isGoalsStepValid(silent = false) {
        //     let valid = true;
        //     this.goalsStepErrors = [];
        //     if(!this.registrationUser.goalId || !this.registrationUser.goalId.length) {
        //         valid = false;
        //         if(!silent) {
        //             this.goalsStepErrors.push('goalId');
        //         }
        //     }
        //     if(!this.registrationUser.interestsIds || this.registrationUser.interestsIds.length < 2) {
        //         valid = false;
        //         if(!silent) {
        //             this.goalsStepErrors.push('interestsIds');
        //         }
        //     }
        //     return valid;
        // },
        stepChanged() {
            if(this.stepDirty) {
                this.stepValid = this.isStepValid();
            }
        },
        getAvailableSteps() {
            let steps = [1];

            if(this.stepOneCompleted()) {
                steps.push(2);
            } else {
                return steps;
            }
           
        //    if(this.stepTwoCompleted()) {
        //         steps.push(3);
        //     } else {
        //         return steps;
        //     }

        //    if(this.stepThreeCompleted()) {
        //         steps.push(4);
        //    }  else {
        //         return steps;
        //     }

            return steps;
        },

        stepOneCompleted() {
            return !!this.$store.state.user
        },

        stepTwoCompleted() {
            return this.isDetailsStepValid(true);
        },

        // stepThreeCompleted() {
        //     return this.isGoalsStepValid(true);; 
        // },

        async submitProfileUpdate() {
             this.registrationUser.name = this.registrationUser.firstName + " " + this.registrationUser.lastName
            //  console.log(this.registrationUser)
            let data = {
                user: {...this.registrationUser}
            }
            delete data.user['profileImageUrl'];
            delete data.user['interests'];
            delete data.user['goal'];

            if(data.user.profileImageKey !== undefined && data.user.profileImageKey === '') {
                delete data.user['profileImageKey'];
            }

            this.submitButtonLoading = true;
            try {
                const response = await api.users.updateProfile(data);
                const responseData = response.data.data;
                storeUser(responseData);
                this.updateSuccess();
            } catch (error) {
                console.error(error);
                console.log(error.response);
                if(error.response.status === 422) {
                    this.submitError = this.$gettext('form_error_cant_update_user');
                }
            } finally {
                this.submitButtonLoading = false;
            }
        },
        updateSuccess() {
            this.$router.push({name: 'Discover'})
        }
    }
}
</script>

<style lang="scss">
.register {
   &__content {
       padding: 40px 20px;
       text-align: center;
   }
   &__wrapper {
       max-width: 560px;
       margin: 0 auto;
       &--small {
        max-width: 445px;
       }
       &--wide {
        max-width: 700px;
       }
   }
   &__section {
       margin-top: 20px;
       margin-bottom: 40px;
   }
   &__heading {
       margin-bottom: 0.7em;
   }
   &__intro {
       font-size: $puma-size-font-md;
       margin-bottom: 20px;
       @include mq(tablet-landscape) {
        font-size: $puma-size-font-lg;
       margin-bottom: 30px;
       }
   }
   &__submit {
       width: 100%;
   }
   &__image {
       width: 100px;
       height: 100px;
       border-radius: 100px;
       overflow: hidden;
       position: relative;
       margin: 0 auto 30px;
       display: block;
       cursor: pointer;
       &.is-loading {
           &::after {
                opacity: 1;
           }
       }
       &::after {
           @include fillout;
           transition: opacity 0.2s;
           content: '';
           background-color: rgba(#000, 0.5);
           opacity: 0;
           pointer-events: none;
           z-index: 3;
       }
       &__empty {
           @include fillout;
           transition: background-color 0.2s;
            background-color: $puma-color-black;
            color: $puma-color-white;
            &:hover {
                background-color: $puma-color-neutral-80;
            }
            &__icon {
                position: absolute;
                top: 50%;
                left: 50%;
                transform: translate(-50%, -50%);
            }
       }
       &__preview {
           position: absolute;
           top: 0;
           left: 0;
           width: 100%;
           height: 100%;
           z-index: 2;
            object-fit: cover;
            object-position: 50% 50%;
       }
       &__input {
           visibility: hidden;
       }
       &__preloader {
           position: absolute;
           top: 50%;
           left: 50%;
           transform: translate(-50%, -50%);
           z-index: 4;
       }
   }
   &__selection {
       display: flex;
       flex-wrap: wrap;
       justify-content: center;
       position: relative;
       min-height: 50px;

       &__item {
           transition: 0.1s;
           font-weight: $font-weight-bold;
           text-transform: uppercase;
           padding: 1em 2.5em;
           background-color: rgba($puma-color-black, 0.1);
           margin: 6px;
           cursor: pointer;
           border: 2px solid transparent;
           user-select: none;
           font-size: $puma-size-font-xs;
           padding: 1em 1.5em;
           @include mq(tablet) {
            padding: 1em 2.5em;
            font-size: $puma-size-font-sm;
           }
           @include mq(tablet-landscape) {
            font-size: $puma-size-font-md;
           }
           &:hover {
               background-color: rgba($puma-color-black, 0);
               border-color: rgba($puma-color-black, 0.1);
           }
           &.is-selected,
           &.is-selected:hover {
               background-color: $puma-color-black;
               color: $puma-color-white;
               border-color: transparent;
           }
       }
   }

    &__preloader {
        margin: 0px auto 30px;
        display: inline-block;
    }

    &__frequency {
        &__row {
            display: flex;
            align-items: center;
            justify-content: center;
            flex-wrap: wrap;
            margin-bottom: 12px;
            &:last-child {
                margin-bottom: 0;
            }
        }
        &__text {
            font-size: $puma-size-font-xl;
            font-weight: $font-weight-bold;
            @include mq(tablet) {
                font-size: $puma-size-font-2xl;
            }
            @include mq(tablet-landscape) {
                font-size: $puma-size-font-3xl;
            }
        }
        &__field {
            margin: 4px 16px;
        }
    }
    &__units {
        position: absolute;
        top: 9px;
        right: 16px;
        display: flex;
        &__item {
            transition: 0.2s opacity;
            font-weight: $font-weight-bold;
            font-size: $puma-size-font-xs;
            opacity: 0.3;
            margin-right: 0.5em;
            padding: 3px 0;
            cursor: pointer;
            &:hover {
                opacity: 0.5;
            }
            &:last-child {
                margin-right: 0;
            }
            &.is-unit-active {
                opacity: 1;
            }
        }
    }
    &__height-area {
        &.is-feet {
            display: flex;
        }
        &__field {
            .is-feet & {
                width: 3.5em;
            }
        }
        &__separator {
            display: none;
            margin: 0 8px 0 4px;
            .is-feet & {
                display: block;
            }
        }
    }

}
</style>